module.exports = __webpack_public_path__ + "img/GYLFW_10.208443ad.jpg";